module.exports = __webpack_public_path__ + "static/img/7.916b463.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/7.png
// module id = Aa5t
// module chunks = 0